import * as actionTypes from './actionTypes';

export const getServices = () => {
    return {
        type: actionTypes.GET_SERVICES
    };
};

export const getServicesSucceeded = (serviceCategories) => {
    return {
        type: actionTypes.GET_SERVICES_SUCCEEDED,
        serviceCategories: serviceCategories
    };
};

export const getProductList = (serviceId, productType) => {
    return {
        type: actionTypes.GET_PRODUCT_LIST,
        serviceId: serviceId,
        productType: productType
    };
};

export const getProductListSucceeded = (productList) => {
    return {
        type: actionTypes.GET_PRODUCT_LIST_SUCCEEDED,
        productList: productList
    };
};

export const getProductListFailed = message => ({
    type: actionTypes.GET_PRODUCT_LIST_FAILED,
    message
});

export const getAvailableTime = (serviceId, roomId, timestamp) => {
    return {
        type: actionTypes.GET_AVAILABLE_TIME,
        serviceId: serviceId,
        roomId: roomId,
        timestamp: timestamp
    };
};

export const getAvailableTimeSucceeded = availableTimeList => ({
    type: actionTypes.GET_AVAILABLE_TIME_SUCCEEDED,
    availableTimeList: availableTimeList
});

export const selectService = serviceID => ({
    type: actionTypes.SELECT_SERVICE,
    serviceID
});

export const selectProduct = product => ({
    type: actionTypes.SELECT_PRODUCT,
    product
});

export const selectTimestamp = timestamp => ({
    type: actionTypes.SELECT_TIMESTAMP,
    timestamp
});